import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="#000000"
					image={require('./image.jpg')}
					title={"What Google has in store for Adwords and your Website"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle david"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>David</strong> on April 13 2018  //  Posted in <strong>Marketing, Advertising</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
								What Google Has In Store For Adwords And Your Website
								</div>
								
								<p>Spring is an exciting time of year – aside from welcoming the warmer weather (debatable at the moment), it is also when Google holds their Partner Masterclass Conference. This conference gives us digital marketers a glimpse of the future of Google’s inner workings – which is a little bit like, as one commentator noted, getting a sneak peak of ‘computer geek porn’. My only complaint is the conference isn’t long enough…</p>

								<div className="tagline">Integration is the Key</div>

								<p>So where is Google going and how will this impact your business’s marketing online? The big word for this year’s conference is integration – giving marketers the tools to draw data from all parts of Google to get the best picture of how a website is performing in relation to market behaviour. ‘Is that it?’, you may ask, but not having this information has been a big stumbling block in the past. Not sure how a website page performs with particular searches? Now you can find out! Not sure if you should advertise on a search term your website performs well on organically? Now you can find out! In a business world where each percent is valuable, these sorts of answers equate to real dollars and cents.</p>

								<div className="tagline">The Need for Speed</div>

								<p>The focus on speed is not new; speed has always been an important aspect of any website design. However, Google is moving even further in favouring those pages that perform over those that do not. You will hear figures bantered around like, ‘a mobile user is likely to leave a page that takes longer than 3 seconds to load’, but in all seriousness, if your website is taking longer than 5 seconds then someone should be looking into it. And if you want an objective rule to go by, put your website into Google’s new test website:</p>

								<p>https://testmysite.thinkwithgoogle.com/</p>

								<p>This will give you a list of issues to address if your website performs poorly, and then with the tools mentioned earlier, every page can be further tested and refined!</p>

								<div className="tagline">Targeting Squared</div>

								<p>The most interesting news for advertisers is the increased ability to target advertising, this time based on customers’ Gmail accounts. You need to have quite a few of these email addresses to start off with, but once you’ve got them, there are heaps of different things you can do. The most obvious is to target display adverts at the clients whose email addresses you know: simple but effective. More interestingly, you can start to segment these people on how they use (or don’t use) your website and direct differently themed adverts at them. Not visited for a while? Bam – here’s a discount! Visited a few times but never purchased? Boom – two for one offer! Received a competitor’s email? (Yes, you read that right), and Kaboom – here is $20 credit to use with us! I tend to agree this is leaning towards the creepier side of personalised marketing but if used well, it will undoubtedly bring results. So start collecting email addresses, though I’m sure you’re already doing this for your email newsletter…right?</p>



							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/GoogleMasterClass/index.js